export default "__VITE_ASSET__NWbImrc___"